import { Box, Flex, Text } from '@chakra-ui/react';
import { Button, Modal } from '@morressier/alembic';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPen } from '@fortawesome/pro-light-svg-icons';
import { IEarlyAssessmentEditorialRequest } from '@publishing-engine/domain/models';
import FileComponent from './FileComponent';

interface Props {
  onClose: () => void;
  isOpen: boolean;
  editorialRequest: IEarlyAssessmentEditorialRequest;
}

const NoteFromEditorModal = ({
  onClose,
  isOpen,
  editorialRequest
}: Props) => {

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      width="45rem"
      closeButtonProps={{
        hidden: true
      }}
    >
      <Flex flexDirection="column" gap={6} padding={8}>
        <Box>
          <FontAwesomeIcon
            icon={faPen}
            size='2x'
          />
        </Box>

        <Flex flexDirection="column" gap={2}>
          <Text textStyle="headingGroup">Note from the Editor</Text>
          <Text textStyle="textBody">
            {editorialRequest?.comment}
          </Text>
        </Flex>

        {editorialRequest?.attachments && editorialRequest?.attachments?.length > 0 && (
          <Flex flexDirection="column" gap={4}>
            <Text textStyle={'headingItem'}>Attached Files</Text>
            {editorialRequest.attachments.map(file => (
              <FileComponent file={file} />
            ))}
          </Flex>
        )}

        <Flex justifyContent="flex-end" gap={2}>
          <Button variant="primary" onClick={onClose}>
            Close
          </Button>
        </Flex>
      </Flex>
    </Modal>
  );
};

export default NoteFromEditorModal;
